import React from 'react';
import { C, DISP, BODY, MONO, FadeUp, Kicker, SectionH2, SectionSub, SECTION_PAD, useSectionView } from './shared';

/* Real-business demonstration using HOOGLAM (the founder's brand).
   All output cards are labelled as an illustrative product demonstration. */

const IDENTIFIES = ['Strongest campaign angle', 'Priority channels', 'Core message', 'Required assets', 'Publishing sequence'];

const OUTPUTS = [
  {
    tag: 'Founder post', channel: 'Instagram / LinkedIn',
    body: '"One week until the new HOOGLAM drop. Here\'s the story behind the piece we almost didn\'t make…"',
  },
  {
    tag: 'Product carousel', channel: 'Instagram',
    body: '5 slides: the drop → the detail shots → how to style it → what it costs → how to get it first.',
  },
  {
    tag: 'Launch email', channel: 'Email list',
    body: 'Subject: "You asked. It\'s back Thursday." Early access for subscribers with one clear CTA.',
  },
  {
    tag: 'Ad concept', channel: 'Meta',
    body: 'Visual: product on bold colour, headline "Made in small runs. Gone in smaller ones." with launch date.',
  },
  {
    tag: 'Landing page section', channel: 'Web',
    body: 'Hero copy, drop countdown, product story block and an email capture for the waitlist.',
  },
  {
    tag: '7-day publishing plan', channel: 'Calendar',
    body: 'Teaser Mon → story post Wed → email Thu → launch day Fri → social proof over the weekend.',
  },
];

export const CampaignDemoSection = () => {
  const ref = useSectionView('campaign_demo');
  return (
    <section id="campaign-demo" ref={ref} style={{ padding: SECTION_PAD, background: 'rgba(255,255,255,0.012)' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <FadeUp><Kicker>A real example</Kicker></FadeUp>
        <FadeUp delay={80}>
          <SectionH2>Watch one launch<br />come together.</SectionH2>
        </FadeUp>
        <FadeUp delay={140}>
          <SectionSub>
            HOOGLAM, the fashion brand where ScalitOS started, has a product drop in seven days and no launch plan. Here is what the campaign workspace produces.
          </SectionSub>
        </FadeUp>

        <FadeUp delay={200}>
          <div style={{ marginTop: 44, display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
            <span style={{ fontFamily: MONO, fontSize: 10.5, letterSpacing: '0.18em', color: C.muted, textTransform: 'uppercase', marginRight: 6 }}>ScalitOS identifies:</span>
            {IDENTIFIES.map((t, i) => (
              <span key={i} style={{ padding: '7px 13px', borderRadius: 999, border: `1px solid ${C.borderLime}`, background: 'rgba(200,241,53,0.05)', fontFamily: BODY, fontSize: 13, fontWeight: 500, color: C.text }}>{t}</span>
            ))}
          </div>
        </FadeUp>

        <div style={{ marginTop: 28, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(300px, 100%), 1fr))', gap: 16 }}>
          {OUTPUTS.map((o, i) => (
            <FadeUp key={i} delay={i * 70}>
              <div className="scl-card" style={{ padding: '24px 22px', border: `1px solid ${C.border}`, borderRadius: 14, background: C.surface, height: '100%' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                  <span style={{ fontFamily: DISP, fontWeight: 700, fontSize: 15, color: C.lime }}>{o.tag}</span>
                  <span style={{ fontFamily: MONO, fontSize: 9.5, letterSpacing: '0.14em', color: C.muted, textTransform: 'uppercase' }}>{o.channel}</span>
                </div>
                <p style={{ fontFamily: BODY, fontSize: 14.5, lineHeight: 1.7, color: C.body }}>{o.body}</p>
              </div>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={300}>
          <p style={{ marginTop: 24, fontFamily: BODY, fontSize: 12.5, color: C.muted, textAlign: 'center' }}>
            Product demonstration. Outputs shown in the campaign workspace format as illustrative concepts, not live screenshots.
          </p>
        </FadeUp>
      </div>
    </section>
  );
};
